import React, { createContext, Dispatch, ReactNode, useReducer } from 'react';

export interface AppointmentCard {
    AvailableAppointmentTime: string[];
    DisplayContent: string;
    Language: string;
    LawfirmId: string;
    SubmitUrl: string;
    TimeZone: string;
    UserName: string;
    UserPhoto: string;
}

export interface RelationQuestion {
    DisplayContent: string;
    Questions: string[];
}

export interface HistoryResponseData {
    Conclusion: string;
    Content: string;
    DisplayName: string;
    DisplayRole: string;
    ErrorCode: number;
    ErrorMessage: string;
    SendTime: number;
    ContentType: "AppointmentCard" | "RelationQuestion" | "Normal";
}

interface State {
  initialized: boolean;
  chatHistory: HistoryResponseData[];
  welcomeMessage: string[];
  config: any; // Replace 'any' with the actual type of your config state
  hasDisplayedWelcome: boolean;
  submitCustomizedMessage: string;
  lawfirmLogo: string;
  lawfirmName: string;
  botAvatarUrl: string;
  botName: string;
  chatBotContainerToggle: boolean;
}

// Define the enum for action types
enum ActionType {
  INITIALIZED = 'INITIALIZED',
  CHAT_HISTORY = 'CHAT_HISTORY',
  WELCOME_MESSAGE = 'WELCOME_MESSAGE',
  CONFIG = 'CONFIG',
  HAS_DISPLAYED_WELCOME = 'HAS_DISPLAYED_WELCOME',
  SUBMIT_CUSTOMIZED_MESSAGE = 'SUBMIT_CUSTOMIZED_MESSAGE',
  LAW_FIRM_LOGO = 'LAW_FIRM_LOGO',
  LAW_FIRM_NAME = 'LAW_FIRM_NAME',
  BOT_AVATAR_URL = 'BOT_AVATAR_URL',
  BOT_NAME = 'BOT_NAME',
  CHAT_BOT_CONTAINER_TOGGLE = 'CHAT_BOT_CONTAINER_TOGGLE',
}

interface Action {
  type: ActionType;
  payload: any; // Replace 'any' with the actual type of your action payload
}

const initialState: State = {
  initialized: false,
  chatHistory: [],
  welcomeMessage: [],
  config: {}, // Initialize with your actual initial config state
  hasDisplayedWelcome: false,
  submitCustomizedMessage: '',
  lawfirmLogo: '',
  lawfirmName: '',
  botAvatarUrl: '',
  botName: '',
  chatBotContainerToggle: false,
};

const store = createContext<{
  state: State;
  dispatch: Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null,
});

const {Provider} = store;
const StateProvider: React.FC<{
  children: ReactNode
}> = ({children}) => {
  const [state, dispatch] = useReducer((state: State, action: Action) => {
    switch (action.type) {
      case ActionType.INITIALIZED:
        console.log('INITIALIZED', action.payload)
        return {...state, initialized: action.payload};
      case ActionType.CHAT_HISTORY:
        console.log('CHAT_HISTORY', action.payload)
        return {...state, chatHistory: action.payload};
      case ActionType.WELCOME_MESSAGE:
        console.log('WELCOME_MESSAGE', action.payload)
        return {...state, welcomeMessage: action.payload};
      case ActionType.CONFIG:
        return {...state, config: action.payload};
      case ActionType.HAS_DISPLAYED_WELCOME:
        return {...state, hasDisplayedWelcome: action.payload};
      case ActionType.SUBMIT_CUSTOMIZED_MESSAGE:
        return {...state, submitCustomizedMessage: action.payload};
      case ActionType.LAW_FIRM_LOGO:
        return {...state, lawfirmLogo: action.payload};
      case ActionType.LAW_FIRM_NAME:
        return {...state, lawfirmName: action.payload};
      case ActionType.BOT_AVATAR_URL:
        return {...state, botAvatarUrl: action.payload};
      case ActionType.BOT_NAME:
        return {...state, botName: action.payload};
      case ActionType.CHAT_BOT_CONTAINER_TOGGLE:
        return {...state, chatBotContainerToggle: action.payload};
      default:
        throw new Error();
    }
    ;
  }, initialState);

  return <Provider value={{state, dispatch}}>{children}</Provider>;
};

export { store, StateProvider, ActionType }
